module.exports = __webpack_public_path__ + "assets/img/serve6.f7c4f0ef.png";